import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LoginPage } from "./Login";
import { PhoneLoginPage } from "./Login/PhoneLogin";
import { LoginCallbackPage } from "./LoginCallback";
import { LogoutPage } from "./Logout";
import { ManagePage } from "./Manage";
import { SignupPage } from "./Signup";
import {
  getUrlToLoginPage,
  getUrlToManagePage,
  geturlToLogoutPage,
  getUrlToSignupPage,
  getUrlToLoginCallbackPage,
  getUrlToPhoneLoginPage,
  getUrlToTermsAndConditionsPage,
  getUrlToAboutUsPage,
  getUrlToGoogleLoginPage,
  getUrlToGoogleLoginCallbackPage,
  getUrlToForgotPasswordPage,
} from "./urls";
import { TermsAndConditionsPage } from "./TermsAndConditions";
import { AboutUs } from "./AboutUs";
import { GoogleLoginInitPage } from "./Login/GoogleLogin/Init";
import { GoogleLoginCallbackPage } from "./Login/GoogleLogin/Callback";
import { ForgotPasswordPage } from "./ForgotPassword";

export function Pages() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={getUrlToLoginPage()} />} />
        <Route
          path={getUrlToLoginCallbackPage()}
          element={<LoginCallbackPage />}
        />
        <Route path={getUrlToGoogleLoginPage()} element={<GoogleLoginInitPage />} />
        <Route path={getUrlToGoogleLoginCallbackPage()} element={<GoogleLoginCallbackPage />} />
        <Route path={getUrlToLoginPage()} element={<LoginPage />} />
        <Route path={getUrlToPhoneLoginPage()} element={<PhoneLoginPage />} />
        <Route path={getUrlToSignupPage()} element={<SignupPage />} />
        <Route path={getUrlToManagePage()} element={<ManagePage />} />
        <Route path={geturlToLogoutPage()} element={<LogoutPage />} />
        <Route path={getUrlToForgotPasswordPage()} element={<ForgotPasswordPage />} />
        <Route
          path={getUrlToTermsAndConditionsPage()}
          element={<TermsAndConditionsPage />}
        />
        <Route path={getUrlToAboutUsPage()} element={<AboutUs />} />
        <Route path="*" element={<div> Not Found </div>} />
      </Routes>
    </BrowserRouter>
  );
}
